<template>
  <div>
    <div class="is-flex flex-direction--column">
      <div class="is-align-content-center">
        <font-awesome-icon
          v-for="(level, idx) in progressLevel"
          :key="`level-${idx}`"
          class="fa-lg margin-right-icon"
          :class="level.class"
          :icon="['fas', 'rectangle-wide']"
        />
      </div>
      <div :class="{ 'profileHeader' : header, 'has-text-weight-bold' : !header }">
        {{ displayMessage }}
        <!-- Near Match System Label needed -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faRectangleWide } from '@fortawesome/pro-solid-svg-icons';

library.add(faRectangleWide);

const progressBar = [];
for (let i = 0; i < 5; i += 1) progressBar.push({});

export default {
  props: {
    header: Boolean, // Helps bind a class when used in header or when used in a row
    processStatus: [Number, String], // To catch the Batch or Transaction status
  },
  async created() {
    try {
      await Promise.all([
        this.loadPidTransactionStatuses(),
      ]);
    } catch (err) {
      // do nothing
    }
  },
  computed: {
    ...mapGetters('lookups', [
      'pidTransactionStatuses',
    ]),
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    displayMessage() {
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(this.processStatus)) {
        if (this.processStatus === 'LOADED') {
          return 'Pending: Request Loaded';
        }
        if (this.processStatus === 'QUEUED') {
          return 'Pending: Request Queued';
        }
        if (this.processStatus === 'RUNNING_MATCHING') {
          return 'Pending: Assignment In Progress';
        }
        if (this.processStatus === 'ERRORED'
            || this.processStatus === 'ERRORED_VALIDATION') {
          return 'Pending: Validation Errors';
        }
        if (this.processStatus === 'ERRORED_MATCHING') {
          return 'Pending: Matching Errors';
        }
        if (this.processStatus === 'COMPLETED_WITH_PENDING') {
          return `Pending: ${this.properties['SYSTEM_LABEL-NEARMATCH']}(s/es)`;
          // Not applying System Label for Transactions
          // Near Match System Label needed
        }
        if (this.processStatus === 'COMPLETED') {
          return 'Completed';
        }
        if (this.processStatus === 'REJECTED') {
          return 'Completed: Rejected';
        }
        if (this.processStatus === 'VALIDATION_IN_PROGRESS') {
          return 'Pending: Validation In Progress';
        }
        if (this.processStatus === 'VALIDATION_COMPLETE') {
          return 'Pending: Validation Completed';
        }
        if (this.processStatus === 'VALIDATION_CANCELED') {
          return 'Completed: Validation Canceled';
        }
        return null;
      }
      // eslint-disable-next-line no-restricted-globals
      if (!isNaN(this.processStatus)) {
        const status = this.pidTransactionStatuses
          .flatMap(g => g.list)
          .find(s => s.id === this.processStatus);
        if (status) {
          return status.prefix + (status.info ? `: ${status.info.trim()}` : '');
        }
        return 'Pending: In Progress';
      }
      return null;
    },
    completedLevels() {
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(this.processStatus)) {
        if (this.processStatus === 'LOADED') {
          return 1;
        }
        if (this.processStatus === 'QUEUED') {
          return 2;
        }
        if (this.processStatus === 'ERRORED'
            || this.processStatus === 'ERRORED_VALIDATION'
            || this.processStatus === 'ERRORED_MATCHING'
            || this.processStatus === 'RUNNING_MATCHING'
            || this.processStatus === 'VALIDATION_COMPLETE'
            || this.processStatus === 'VALIDATION_IN_PROGRESS') {
          return 3;
        }
        if (this.processStatus === 'COMPLETED_WITH_PENDING') {
          return 4;
        }
        if (this.processStatus === 'COMPLETED'
            || this.processStatus === 'VALIDATION_CANCELED') {
          return 5;
        }
        if (this.processStatus === 'REJECTED') {
          return 5;
        }
        return 0;
      }
      // eslint-disable-next-line no-restricted-globals
      if (!isNaN(this.processStatus)) {
        const status = this.pidTransactionStatuses
          .flatMap(g => g.list)
          .find(s => s.id === this.processStatus);
        if (status) {
          switch (status.prefix) {
            case 'Completed':
              return 5;
            case 'Pending':
              return 4;
            default:
              return 2;
          }
        }
        return 2;
      }
      return null;
    },
    progressLevel() {
      progressBar.forEach((l, index) => {
        let progressClass;
        if (index < this.completedLevels) {
          progressClass = (this.processStatus === 'REJECTED') ? 'danger' : 'has-text-success';
        } else {
          progressClass = 'has-text-grey-lighter';
        }
        progressBar[index].class = progressClass;
      });
      return progressBar;
    },
  },
  methods: {
    ...mapActions('lookups', [
      'loadPidTransactionStatuses',
    ]),
  },
};
</script>

<style lang="sass" scoped>
  .margin-right-icon
    margin-right: 2px
  .profileHeader
    color: #000
    font-size: 16px
    font-weight: 600
  .danger
    color: #DC3545
</style>
